export const responsiveWatcher = {
  computed: {
    isMobile () {
      return !this.$screen.md;
    },
  },
};
